var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { cx, css as emotionCss } from 'emotion';
import { Row as Component } from './Layout.styled';
import { getAutomation, getDebug } from '@citrus/runtime';
import { get, isNotNilOrEmpty, last } from '@pcty/utils';
var VERSION = '6.7.2';
var Row = React.forwardRef(function (_a, ref) {
    var _b;
    var automationId = _a.automationId, children = _a.children, className = _a.className, css = _a.css, layout = _a.layout, margin = _a.margin, padding = _a.padding, _c = _a.noGutters, noGutters = _c === void 0 ? false : _c, __TYPE = _a.__TYPE, other = __rest(_a, ["automationId", "children", "className", "css", "layout", "margin", "padding", "noGutters", "__TYPE"]);
    var _css = [
        'pcty-row-flex',
        noGutters ? 'pcty-no-gutters' : '',
        margin ? 'pcty-margin-' + margin : '',
        margin && margin.indexOf('compact') >= 0 ? 'pcty-compact-margin-' + last(margin.split('-')) : '',
        padding && padding.indexOf('compact') < 0 ? 'pcty-padding-' + padding : '',
        padding && padding.indexOf('compact') >= 0 ? 'pcty-compact-padding-' + last(padding.split('-')) : '',
        className || '',
    ]
        .filter(function (x) { return x.length > 0; })
        .join(' ')
        .trim();
    var classes = cx(_css, (_b = {},
        _b[emotionCss(css)] = isNotNilOrEmpty(css),
        _b));
    return (React.createElement(Component, __assign({ className: classes, ref: ref }, other, getAutomation(automationId), getDebug(sessionStorage.getItem('citrus-debug') === 'true', __TYPE, VERSION)), renderLayout(layout, children)));
});
var renderLayout = function (layout, children) {
    switch (layout) {
        case 'sidebarContent':
            return renderSidebarContentLayoutChildren(children);
        case 'contentSidebar':
            return renderContentSidebarLayoutChildren(children);
        default:
            return renderChildren(children);
    }
};
var renderChildren = function (children) {
    return React.Children.map(children, function (child) { return (get(child, 'props.__TYPE', null) !== 'Col' ? null : child); });
};
var renderSidebarContentLayoutChildren = function (children) {
    return React.Children.map(children, function (child, i) {
        if (child.props.__TYPE !== 'Col' || i >= 2)
            return null;
        if (i === 0) {
            return React.cloneElement(child, { sm: 3 });
        }
        if (i === 1) {
            var className = 'pcty-border-left pcty-border-left-xs-none';
            if (!!child.props.className) {
                className += ' ' + child.props.className;
            }
            return React.cloneElement(child, { className: className });
        }
    });
};
var renderContentSidebarLayoutChildren = function (children) {
    return React.Children.map(children, function (child, i) {
        if (child.props.__TYPE !== 'Col' || i >= 2)
            return null;
        if (i === 0) {
            var className = 'pcty-border-right pcty-border-right-xs-none';
            if (!!child.props.className) {
                className += ' ' + child.props.className;
            }
            return React.cloneElement(child, {
                className: className,
            });
        }
        if (i === 1) {
            return React.cloneElement(child, { sm: 3 });
        }
    });
};
Row.defaultProps = {
    __TYPE: 'Row',
};
export default Row;
